import { cn } from "@/lib/utils";

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className={cn("text-center py-12 px-4")}>
      {Icon && (
        <div className="mx-auto size-12 rounded-xl bg-muted grid place-items-center mb-3 text-muted-foreground">
          <Icon className="size-6" />
        </div>
      )}
      <h3 className="font-display font-semibold text-foreground">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
